module.exports = __webpack_public_path__ + "static/manage_multiple_sites-3669d8907c69dc9ee6fad29f304c0da8.png";